export default __webpack_public_path__ + "static/media/header.0a9e7c49.png";